import React, { useEffect, useRef, useState } from "react";
import { ActionIcon, Box, Select } from "@mantine/core";
import { IconFilter } from "@tabler/icons-react";

export interface OptionValue {
  value: string;
  label: string;
}

interface FilterDropdownProps {
  values: OptionValue[];
  setSelectedValue: (option: string | null) => void;
  selectedValue: string | null;
}
const TableFilterDropdown: React.FC<FilterDropdownProps> = ({
  values,
  setSelectedValue,
  selectedValue,
}: FilterDropdownProps) => {
  const [dropdownOpened, setDropdownOpened] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      // Search for class of option wrapper.
      // Search for parent class as well because, user can click on nested span or item itself
      const targetClasses: string = (
        event.target as Element
      ).className.toString();
      const parentClasses: string = (
        (event.target as Element).parentNode as Element
      ).className.toString();
      //Close dropdown on click everywhere on document except on filter action icon and option elements.
      if (
        !targetClasses.includes("mantine-ActionIcon-icon") &&
        !parentClasses.includes("mantine-ActionIcon-icon") &&
        !targetClasses.includes("mantine-Select-option") &&
        !parentClasses.includes("mantine-Select-option")
      ) {
        setDropdownOpened(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <Box
      ref={wrapperRef}
      style={{
        position: "relative",
        width: "fit-content",
        marginLeft: "5px",
      }}
    >
      <ActionIcon
        onClick={() => setDropdownOpened(!dropdownOpened)}
        variant={"default"}
        style={{
          position: "absolute",
          zIndex: 5,
          left: 0,
          color: "var(--mid-dark)",
          border: "none",
        }}
      >
        <IconFilter width={20} />
      </ActionIcon>
      <Select
        w={250}
        styles={{
          root: {
            position: "absolute",
          },
          input: {
            color: "var(--mid-dark)",
            fontWeight: 600,
            fontSize: "var(--module-size-14)",
            opacity: 0,
          },
          section: { display: "none" },
          option: {
            color: "var(--mid-dark)",
            fontSize: "var(--module-size-14)",
          },
        }}
        data={values}
        defaultValue={"all"}
        value={selectedValue ?? "all"}
        dropdownOpened={dropdownOpened}
        onChange={(value) => {
          setSelectedValue(value === "all" ? null : value);
          setDropdownOpened(false);
        }}
      />
    </Box>
  );
};

export default TableFilterDropdown;
